/**
 *  Module for model and alternate views display
 */

const Price = function(app) {

  // const _ = require('lodash'),
  //   numeral = require('numeral');

  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    $container = app.$container;

  function getPrice(withoutSymbol) {
    const price = configure.run('getPrice');
    // // Format the currency and return the value
    let formatedPrice = (!withoutSymbol) ? configure.run('formatPrice', price) : price;
    if (formatedPrice.toString().indexOf('€') > -1) {
      formatedPrice = formatedPrice.replace('€', '') + '€';
    }
    return `${formatedPrice} ${app.l10n.getLang('tax_exclusive', '')}`;
  }

  function init() {
    $container.find('.fc-price-container').html(getPrice);
  }

  /**
   *  Expose Public Properties/Methods
   */
  return {
    getPrice,
    init
  };
};

module.exports = Price;
